"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icons_1 = require("../icons");
var grid_1 = require("./grid");
var spacing_1 = require("./spacing");
var tracking_1 = require("../util/tracking");
var NavLink_1 = __importDefault(require("./NavLink"));
var configs = {
    phone: {
        href: 'tel:+18554295369',
        icon: icons_1.Phone,
        text: ' Call 855-429-5369',
    },
    email: {
        href: 'mailto:hello@gethank.com?subject=Question%20about%20Hank%20',
        icon: icons_1.Mail,
        text: ' hello@gethank.com',
        popout: true,
    },
    chat: {
        chat: true,
        icon: icons_1.MessageCircle,
        text: 'Ask us anything',
    },
};
var IconLink = function (_a) {
    var variant = _a.variant, color = _a.color, _b = _a.narrow, narrow = _b === void 0 ? false : _b, trackProps = _a.trackProps;
    var conf = configs[variant];
    var onClick = trackProps ? function () { return (0, tracking_1.track)(trackProps); } : function () { };
    var navProps = __assign(__assign(__assign({ onClick: onClick, color: color }, (conf.chat && {
        onClick: function () {
            window.zE && window.zE.activate();
            onClick();
        },
    })), (conf.href && { href: conf.href })), (conf.popout && { target: '_blank', rel: 'noopener noreferrer' }));
    return (react_1.default.createElement(NavLink_1.default, __assign({}, navProps),
        react_1.default.createElement(grid_1.Container, { align: "center" },
            react_1.default.createElement(conf.icon, { color: color }),
            !narrow && react_1.default.createElement(spacing_1.Div, { pl: 1 }, conf.text))));
};
exports.default = IconLink;
//# sourceMappingURL=IconLink.js.map